import { Controller, type UseFormReturn } from 'react-hook-form'

import { FreightAllocationEditor } from '@/components/freight/FreightAllocationEditor'
import type { FreightEditorAudience } from '@/components/freight/freightEditorAudience'
import { FieldError } from '@/components/ui/field'
import { FillFieldKey, useFieldCheck, useFreightSuggestions } from '@/models/fillApplication'
import type { FreightValues } from './useFreightForm'

interface FreightFieldProps {
  orgId: string
  form: UseFormReturn<FreightValues>
  /** Staff's wording unless the customer fills it in. */
  audience?: FreightEditorAudience
}

export function FreightField({ orgId, form, audience }: FreightFieldProps) {
  const { suggestions, suggestionGroups, fmcsaCargo } = useFreightSuggestions(orgId)
  const check = useFieldCheck(FillFieldKey.FREIGHT)

  return (
    <Controller
      name="commodities"
      control={form.control}
      render={({ field, fieldState }) => (
        <div className="flex flex-col gap-2" data-fill-field={FillFieldKey.FREIGHT}>
          <FreightAllocationEditor
            id="fill-freight"
            value={field.value}
            onChange={field.onChange}
            suggestions={suggestions}
            suggestionGroups={suggestionGroups}
            fmcsaCargo={fmcsaCargo}
            audience={audience}
          />
          <FieldError>{fieldState.error?.message ?? check}</FieldError>
        </div>
      )}
    />
  )
}
